module.exports = __webpack_public_path__ + "img/logo-white.e94735bd.png";